//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from "vuex";
import DiagramWrapper from "@/components/Diagram/DiagramWrapper/DiagramWrapper.vue";

export default {
    components: {
        DiagramWrapper
    },
    props: {
        processInstance: String
    },
    data() {
        const vm = this;

        return {
            opened: true,
            showLoading: true,
            diagramContainerStyles: {
                // "min-height": "calc(100vh - 51px)",
                width: "100%"
            }
        };
    },
    methods: {
        onDiagramEventTracer(data) {
            const vm = this;

            if (data.type === "PLUGIN_SELECTED") {
                vm.$store.commit("diagrams/selectedPluginCode", data.payload.PLUGIN_ID);
                vm.$store.commit(
                    "diagrams/selectedPluginUuid",
                    data.payload.PLUGIN_UUID
                );
            }
            if (data.type === "DIAGRAM_VIEW_INITIALIZED") {
                vm.$store
                    .dispatch("diagrams/getDataJson", { apptracer: true })
                    .then(() => {
                        vm.$refs.tracer.changeDataSet(vm.diagramData);
                        vm.$refs.tracer.setReadonly(true);
                        // disable all connectors
                        vm.diagramData.connectors.filter((connector) => {
                            vm.$refs.tracer.updatePluginState({ disabled: true, readonlyDisabled: true }, connector.uuid, false, true);
                        });
                        vm.diagramData.content.filter((item) => {
                            vm.$refs.tracer.updatePluginState({ disabled: true, readonlyDisabled: true }, item.uuid);
                        });
                        // vm.$store.dispatch("diagrams/getAuditTrail", '7c15cf03-95cd-4a6e-84e6-15100fd0818e')
                        vm.$store.dispatch("diagrams/getAuditTrail", this.processInstance)
                            .then(() => {
                                if (vm.diagramData) {
                                    const allAvailablePlugins = [];
                                    const allAvailablePluginsData = [];
                                    let hasParalelJoinScenario = false;

                                    this.auditTrail.forEach(element => {
                                        const elementExistOnDiagram = vm.diagramData.content.find(plugin => plugin.uuid === element.activityId);
                                        if (elementExistOnDiagram && element.activityId && allAvailablePlugins.indexOf(element.activityId) === -1) {
                                            allAvailablePlugins.unshift(element.activityId);
                                            allAvailablePluginsData.unshift(element);
                                        }
                                    });

                                    for (var i in allAvailablePluginsData) {
                                        if (allAvailablePluginsData[i].activityId) {
                                            vm.diagramData.connectors.filter((connector) => {
                                                if (allAvailablePluginsData[i].activityId === connector.uuid) {
                                                    vm.$refs.tracer.updatePluginState({ disabled: false }, connector.uuid, false, true);
                                                }
                                            });
                                            vm.diagramData.content.filter((item) => {
                                                if (allAvailablePluginsData[i].activityId === item.uuid) {
                                                    // for every plugin if plugin.id !== item.id this.updatePluginState({disabel: true})
                                                    const index = allAvailablePlugins.indexOf(allAvailablePluginsData[i].activityId);
                                                    const stateObject = {
                                                        disabled: false,
                                                        pluginIndex: index ? index + 1 : null
                                                    };

                                                    if (allAvailablePluginsData[i].type === "JOIN_GATEWAY_PLUGIN") {
                                                        hasParalelJoinScenario = false;
                                                    }
                                                    if (allAvailablePluginsData[i].type === "PARALLEL_GATEWAY_PLUGIN") {
                                                        hasParalelJoinScenario = true;
                                                    } else if (hasParalelJoinScenario) {
                                                        stateObject.pluginIndex = null;
                                                        stateObject.insideParallelIndex = "insideParallel";
                                                    }

                                                    vm.$refs.tracer.updatePluginState(stateObject, item.uuid);
                                                }
                                            });
                                        }
                                    }
                                    this.$refs.tracer.resetDiagramScroll();
                                    this.showLoading = false;
                                }
                            });
                    });
            }
        }
    },
    computed: {
        ...mapGetters("diagrams", ["diagramConfigData", "diagramData", "appTracer"]),
        ...mapState("diagrams", ["auditTrail"]),
        config() {
            return { readonly: true };
        }
    },
    mounted() {
    }
};
